<template>
  <div class="x5">
    <div class="x5-1">
      <div class="overlap-group1-2">
        <div class="frame-7">
          <div class="icon">
            <div class="overlap-group-4">
              <div class="bg-4">
                <img
                  class="rectangle-2"
                  src="/otplanding/rectangle@2x.png"
                  alt="Rectangle"
                />
              </div>
              <img
                class="shape"
                src="/otplanding/shape-1@2x.png"
                alt="Shape"
              />
            </div>
          </div>
          <div class="text-4">
            <p class="duis-aute-irure-dolo-3 inter-normal-gull-gray-18px">
              automatizovan sistem lojalnosti kupaca<br />analitika potrošačkih navika<br />direktan kontakt sa
              kupcem<br />targetirani marketing
            </p>
            <div class="instant-features-2 inter-bold-link-water-24px">
              <span class="inter-bold-link-water-24px">Kupoholičar </span
              ><span class="inter-medium-link-water-24px">loyalty</span>
            </div>
          </div>
        </div>
        <div class="uskoro-2 inter-bold-link-water-24px">uskoro</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "X5",
};
</script>

<style>
.x5,
.x5-2 {
  display: flex;
  height: 247px;
  min-width: 327px;
  position: relative;
}

.x5-1,
.x5-3 {
  align-items: flex-start;
  display: flex;
  flex: 1;
  margin-right: -2px;
  min-width: calc(100% + 2px);
}

.overlap-group1-2,
.overlap-group1-3 {
  height: 247px;
  position: relative;
  width: 327px;
}

.frame-7,
.frame-7-1 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  left: 0;
  position: absolute;
  top: 17px;
  width: 326px;
}

.icon,
.icon-1 {
  height: 64px;
  min-width: 64px;
  position: relative;
}

.overlap-group-4,
.overlap-group-5 {
  height: 64px;
  position: relative;
  width: 64px;
}

.bg-4,
.bg-5 {
  display: flex;
  height: 64px;
  left: 0;
  position: absolute;
  top: 0;
  width: 64px;
}

.rectangle-2,
.rectangle-3 {
  flex: 1;
  height: 65px;
  margin-left: -0.5px;
  margin-right: -0.5px;
  margin-top: -0.5px;
  object-fit: cover;
}

.shape,
.shape-1 {
  height: 36px;
  left: 15px;
  object-fit: cover;
  position: absolute;
  top: 14px;
  width: 33px;
}

.text-4,
.text-5 {
  height: 150px;
  min-width: 326px;
  position: relative;
}

.duis-aute-irure-dolo-3,
.duis-aute-irure-dolo-4 {
  left: 0;
  letter-spacing: -0.25px;
  line-height: 27px;
  position: absolute;
  text-align: center;
  top: 42px;
  width: 326px;
}

.instant-features-2,
.instant-features-3 {
  left: 38px;
  letter-spacing: -0.25px;
  line-height: 34px;
  position: absolute;
  text-align: center;
  text-decoration: underline;
  top: 0;
  white-space: nowrap;
  width: 251px;
}

.uskoro-2,
.uskoro-3 {
  left: 195px;
  letter-spacing: -0.25px;
  line-height: 34px;
  position: absolute;
  text-align: center;
  top: 0;
  white-space: nowrap;
  width: 132px;
}
</style>
